// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,


  //    STRIPE REQUIRES FULL URL - NOT RELATIVE PATHS

  // baseUrl: 'http://localhost:4200/',
  // billingReturnURL: 'http://localhost:4200/member',
  // successUrl: 'http://localhost:4200/success',
  // cancelUrl: 'http://localhost:4200/failure',

  baseUrl: 'https://beta.rrbootcamp.com/',
  billingReturnURL: 'https://beta.rrbootcamp.com/member',
  successUrl: 'https://beta.rrbootcamp.com/success',
  cancelUrl: 'https://beta.rrbootcamp.com/failure'

};

